import {useContext} from 'react'
import { Link } from "react-router-dom";
import FavoritesContext from '../../store/favorites-context';
import classes from './MainNavigation.module.css'
function MainNavigation() {

  const favoritesCtx =useContext(FavoritesContext)
  return (
      <header className={classes.header}>
    <div className={classes.logo}>Learner</div>
      <nav>
        <ul>
          <li>
            <Link to="/">All Meetup</Link>
          </li>
          <li>
            <Link to="/new-meetup">Add New Meetup</Link>
          </li>
          <li>
            <Link to="/favorites">My Favorites <span className={classes.badge}>{favoritesCtx.totalFavorites}</span></Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default MainNavigation;
